import { ACCESS_QUERY_KEY } from "~/access/queryKeys";
import {
  RESET,
  orgsAtom,
  selectedAccessRoleIdAtom,
  store,
  userAtom,
  userConfigAtom,
  workosAuthAtom,
  workosAuthInitialState,
  zitadelOrgAtom,
} from "~/atoms";
import { queryClient } from "~/lib/queryClient";

export const resetSessionAtoms = () => {
  queryClient.removeQueries({ queryKey: ACCESS_QUERY_KEY });
  store.set(selectedAccessRoleIdAtom, RESET);
  store.set(orgsAtom, RESET);
  store.set(userAtom, RESET);
  store.set(userConfigAtom, RESET);
  store.set(zitadelOrgAtom, RESET);
  store.set(workosAuthAtom, workosAuthInitialState);
};
